module.exports = __webpack_public_path__ + "7ec9bb52724f707f6568df7a6a7cd3d8.pdf";